import { render, staticRenderFns } from "./StaffsListPage.vue?vue&type=template&id=5fef86c5&"
import script from "./StaffsListPage.vue?vue&type=script&lang=ts&"
export * from "./StaffsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports